module.exports = __webpack_public_path__ + "media/images/games/35gender/country-fc1ec5453a54fd000df2addbf38f56f1.png";